
import { NotificationsResponse } from "@/models/interfaces/responses/NotificationsResponse";
import { AxiosResponse } from "axios";
import api from "./axios";


export function GetNotifications(page=1): Promise<AxiosResponse<NotificationsResponse, any>> {
  return api.get<NotificationsResponse>(`v2/notification?page=${page}`);
}
